import { tieneAccesoTotal } from "@/utils/roles";
import axios from "axios";

export default {
  async regionAvailable(context, country_code) {
    const availableCountries = ["ES", "CO", "IT"];
    return availableCountries.includes(country_code);
  },

  async getProperty({ commit }, id_accommodation) {
    try {
      const result = await axios.get(`/get-property`, {
        params: { id_accommodation },
      });
      commit("SET_PROPERTY", result);
      return result.data;
    } catch (error) {
      console.log(error);
    }
  },

  async getProperties({ commit, rootState }, user_id) {
    const uid = user_id || rootState.userRoot?.id;

    try {
      const response = await axios.post("/retrive-properties", { user_id: uid });

      let list = Array.isArray(response.data) ? response.data : [];

      /* Los miembros con propiedades asignadas trabajan solo con esas. Los de acceso
         total (anfitrión invitado, gestor, coanfitrión) ven todas: a esos NO se les
         filtra, porque no tienen asignaciones y se quedarían con la lista vacía — y con
         cero propiedades el panel los manda a crear su primer alojamiento. */
      const subUser = rootState.subUser;
      if (subUser && !tieneAccesoTotal(subUser)) {
        const allowed = Array.isArray(subUser.assigned_property_ids)
          ? subUser.assigned_property_ids.map(Number)
          : [];
        list = list.filter((p) => allowed.includes(Number(p.id)));
      }

      commit("SET_PROPERTIES", list);

      if (list.length > 0) {
        const storedId = Number(localStorage.getItem("propiedadActiva") || 0);

        const storedIsValid =
          storedId && list.some((p) => Number(p.id) === storedId);

        const defaultId = storedIsValid ? storedId : Number(list[0].id);

        if (defaultId && Number(rootState.propiedadActiva) !== defaultId) {
          commit("SET_ACTIVE_PROPERTY", defaultId, { root: true });
        }
      }

      return list;
    } catch (error) {
      console.log("error => ", error);
    }
  },

  async getProperties_back({ commit }, user_id) {
    const sendData = {
      user_id,
    };

    try {
      const response = await axios.post("/retrive-properties", sendData);
      commit("SET_PROPERTIES", response.data);
      return response.data;
    } catch (error) {
      console.log("error => ", error);
    }
  },

  updateTemplate({ commit }, payload) {
    commit("SET_TEMPLATE", payload);
  },

  validateStep({ commit, state, rootState }, step) {
    let isValid = false;
    const hasServices = Array.isArray(state.template.services) && state.template.services.length > 0;
    const price = Number(state.template.priceNight);
    const hasPrice = Number.isFinite(price) && price > 0;
    const hasCurrency = !!String(state.template.currency || "").trim();

    const type = (state.template?.type || rootState.userRoot?.tipo_hospedaje || "")
      .toString()
      .toLowerCase();

    switch (step) {
      case 1:
        isValid = !!state.template.nombre?.trim();
        break;

      case 2:
        if (type === "apartamento" || type === "villa") {
          isValid = true;
        } else if (type === "hotel" || type === "camping") {
          isValid = hasServices;
        }
        break;

      case 3:
        if (type === "apartamento" || type === "villa") {
          isValid = hasServices;
        } else if (type === "hotel" || type === "camping") {
          isValid = hasPrice && hasCurrency;
        }
        break;

      case 4:
        if (type === "apartamento" || type === "villa") {
          isValid = hasPrice && hasCurrency;
        } else if (type === "hotel" || type === "camping") {
          isValid = !!state.template.description?.trim();
        }
        break;

      case 5:
        if (type === "apartamento" || type === "villa") {
          isValid = !!state.template.description?.trim();
        } else if (type === "hotel" || type === "camping") {
          isValid = true;
        }
        break;

      case 6:
        isValid = true;
        break;

      default:
        isValid = true;
    }

    commit("UPDATE_VALIDATION", { step: `step${step}`, isValid });
    return isValid;
  },
};
